import axios from "axios";

const crypto = window.require("crypto");
const fs = window.require("fs");
const path = window.require("path");
const request = window.require("request");
let interval;

export class NewPrinter {
  instance;

  init(ip) {
    this.instance = axios.create({ baseURL: `http://${ip}:3000`, timeout: 1000 * 5 });
    this.instance.interceptors.response.use((res) => res.data);
  }

  print(ip, filePath, sizes) {
    this.init(ip);
    return this.uploadFile(filePath).then(({ fileName }) =>
      this.instance
        .post("/print", {
          filename: fileName
        })
        .then((res) => {
          const taskName = res.split(" ")[3];

          return this.getPrintState(taskName, sizes);
        })
    );
  }

  parsePrintState(arg) {
    if (arg.indexOf("Status:") >= 0) {
      const arr = arg.split("\n\t");
      const statusIndex = arr[1].indexOf("Status:");
      const alertsIndex = arr[2].indexOf("Alerts:");
      return {
        Status: arr[1].substring(statusIndex + 7).trim(),
        Alerts: arr[2].substring(alertsIndex + 7).trim()
      };
    } else {
      const arr = arg.split("\n\t");
      const alertsIndex = arr[1].indexOf("Alerts:");
      return {
        Status: "waiting",
        Alerts: arr[1].substring(alertsIndex + 7).trim()
      };
    }
  }

  cancelTask(taskName) {
    return this.instance.get(`/cancel?taskName=${taskName}`);
  }

  getPrintState(taskName, sizes) {
    console.log("pdf页数", sizes);
    let startTime = Date.now();
    const emptyCheckDuration = 30 * 1000 * (sizes + 1);
    console.log("空页检测超时时间", emptyCheckDuration / 1000);
    const timeoutCheckDuration = emptyCheckDuration + 50 * 1000;
    return new Promise((s, j) => {
      const clear = (state) => {
        interval && clearTimeout(interval);
        state && j(state);
      };
      clear();
      const check = (isNone = false) => {
        return this.instance
          .get(`/state?taskName=${taskName}`)
          .then((res) => {
            console.log((Date.now() - startTime) / 1000);
            const { Status, Alerts } = this.parsePrintState(res);
            if (Status === "" && Alerts === "processing-to-stop-point") {
              s();
            } else {
              if (Status.includes("empty")) {
                clear({ status: "empty", Status, Alerts });
              } else if (
                (Status === "" && Alerts === "job-canceled-by-user") ||
                Alerts === "processing-to-stop-point" ||
                (Status === "Unable to cancel print job." && Alerts === "job-canceled-by-user")
              ) {
                clear({ status: "cancel", Status, Alerts });
              } else if (
                Status === "Unable to locate printer." ||
                Status === "Waiting for printer to become available."
              ) {
                clear({ status: "error", Status, Alerts });
              } else if (Date.now() - startTime > emptyCheckDuration && !isNone) {
                clear({ status: "empty", Status, Alerts });
              } else if (Date.now() - startTime > timeoutCheckDuration) {
                clear({ status: "timeout", Status, Alerts });
              } else if (Alerts === "none") {
                this.check()
                  .then(() => (interval = setTimeout(() => check(true), 1000)))
                  .catch(clear);
              } else {
                interval = setTimeout(check, 1000);
              }
            }
          })
          .catch(() => clear({ status: "get_state_error" }));
      };
      check();
    }).catch((err) =>
      this.cancelTask(taskName).then(
        () =>
          this.check().then(
            () => Promise.reject(err),
            (err) => Promise.reject(err)
          ),
        () => Promise.reject(err)
      )
    );
  }

  getFileHash(filePath, algorithm = "md5") {
    return new Promise((resolve, reject) => {
      const hash = crypto.createHash(algorithm);
      const stream = fs.createReadStream(filePath);
      stream.on("data", (chunk) => {
        hash.update(chunk);
      });

      stream.on("end", () => {
        resolve(hash.digest("hex"));
      });

      stream.on("error", reject);
    });
  }

  async uploadFile(filePath) {
    const formData = new FormData();
    const fileHash = await this.getFileHash(filePath);
    const file = await new Promise((s, j) =>
      fs.readFile(filePath, (err, data) => {
        if (err) {
          return j(err);
        }

        const uint8Array = new Uint8Array(data);

        const blob = new Blob([uint8Array], { type: "application/pdf" });

        const file = new File([blob], filePath.split("/").pop(), { type: "application/pdf" });

        s(file);
      })
    );
    formData.append("file", file);
    formData.append("hexValue", fileHash);
    return this.instance.post("/uploadFile", formData);
  }

  check() {
    return this.instance.get("/check", { timeout: 1000 * 60 }).then((res) => {
      const arr = res.trim().split("<br>\n").slice(0, 3);
      const result = [];
      arr.forEach((v) => {
        const newarr = v.split("->");
        const newarr1 = newarr.map((item) => item.trim());
        result.push({ name: newarr1[0], pass: newarr1[1], cause: newarr1[2] });
      });
      if (result.every((v) => v.pass === "YES")) return result;
      for (let index = 0; index < result.length; index++) {
        let item = result[index];
        if (item.pass === "NO") {
          return Promise.reject({
            status:
              item.name === "Default printer"
                ? "not_default_printer"
                : item.name === "Default connect"
                  ? "not_connect_printer"
                  : "not_switch_printer",
            name: item.name !== "Default printer" ? item.cause : ""
          });
        }
      }
    });
  }
}

export class Printer {
  httpGet(ip, port, path) {
    return new Promise((resolve, reject) => {
      let url = `http://${ip}:${port}${path}`;
      request(url, { timeout: 1000 }, function (err, response, body) {
        if (err) {
          reject(err);
        } else {
          resolve(body);
        }
      });
    });
  }
  getPrinterState(ip) {
    return new Promise((resolve, reject) => {
      this.httpGet(ip, 3000, "/getPrinterState").then((data) => {
        if (data === "done") {
          resolve("done");
        } else {
          let result = "busy-printer";
          reject(result);
        }
      });
    });
  }
  uploadFile(filePath, ip) {
    return new Promise((resolve, reject) => {
      if (!fs.existsSync(filePath)) {
        let result = "no-file";
        reject(result);
      } else {
        var options = {
          method: "POST",
          url: `http://${ip}:3000/upload`,
          timeout: 20000,
          formData: {
            file: fs.createReadStream(filePath),
            type: "application/octet-stream",
            name: path.basename(filePath)
          }
        };
        request(options, function (error, response) {
          console.log(error);
          if (error) {
            reject(error);
          } else {
            if (response && response.statusCode === 200) {
              resolve();
            } else {
              let error = "error";
              reject(error);
            }
          }
        });
      }
    });
  }
  print(ip, filePath) {
    return new Promise((resolve, reject) => {
      this.getPrinterState(ip)
        .then(() => {
          this.uploadFile(filePath, ip)
            .then(() => {
              resolve();
            })
            .catch((e) => {
              let result = "print-failed-printer";

              reject(result);
            });
        })
        .catch(() => {
          let result = "busy-printer";

          reject(result);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/mainInterface/js/printer/index.js